import { useEffect } from 'react';
import clsx from 'clsx';
import { AText, Box } from '@alf/uikit';
import { useOtherSettings } from '@namespace/cms';
import { useI18n } from '@namespace/i18n';

import styles from './index.module.css';

export const PopupContent = () => {
  const { t } = useI18n();
  const { isShowConfirmDepositPopupThirdBonus = false } = useOtherSettings();

  useEffect(() => {
    document.body.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  return (
    <Box direction="column" className={styles.wrapper}>
      <Box align="center" className={styles.container} margin="m 0">
        <Box className={styles.headLine} />
        <Box direction="column" margin="0 xs 0 0">
          <AText
            size="l"
            breed="BU"
            color="txt_color_3"
            className={styles.title}
          >
            {t('web.deposit.ftd.popup.bonus1.title')}
          </AText>
          <AText
            size="s"
            breed="R"
            color="txt_color_3"
            className={styles.contentItem}
          >
            {t('web.deposit.ftd.popup.bonus1.content')}
          </AText>
        </Box>
        <img
          src="/minio/bonuses/leave-deposit-bonus1.png"
          className={styles.image}
          alt=""
        />
      </Box>
      <Box align="center" className={styles.container} margin="0 0 m 0">
        <Box className={clsx(styles.headLine, styles.headLineSecond)} />
        <Box direction="column" margin="0 xs 0 0">
          <AText
            size="l"
            breed="BU"
            color="txt_color_3"
            className={styles.title}
          >
            {t('web.deposit.ftd.popup.bonus2.title')}
          </AText>
          <AText
            size="s"
            breed="R"
            color="txt_color_3"
            className={styles.contentItem}
          >
            {t('web.deposit.ftd.popup.bonus2.content')}
          </AText>
        </Box>
        <img
          src="/minio/bonuses/leave-deposit-bonus2.png"
          className={styles.image}
          alt=""
        />
      </Box>
      {isShowConfirmDepositPopupThirdBonus && (
        <Box align="center" className={styles.container} margin="0 0 m 0">
          <Box className={clsx(styles.headLine, styles.headLineThird)} />
          <Box direction="column" margin="0 xs 0 0">
            <AText
              size="l"
              breed="BU"
              color="txt_color_3"
              className={styles.title}
            >
              {t('web.deposit.ftd.popup.bonus3.title')}
            </AText>
            <AText
              size="s"
              breed="R"
              color="txt_color_3"
              className={styles.contentItem}
            >
              {t('web.deposit.ftd.popup.bonus3.content')}
            </AText>
          </Box>
          <img
            src="/minio/bonuses/leave-deposit-bonus3.png"
            className={styles.image}
            alt=""
          />
        </Box>
      )}
    </Box>
  );
};
